var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.show)?_c('header-menu'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.show)?_c('Bottom'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }